import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  Image,
  Spacer,
} from "@chakra-ui/react";
import LockOpend from "../../../assets/illustrations/lockedOpend.svg";
import { useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  return (
    <Box
      color="white"
      p={8}
      borderRadius="xl"
      h={"100vh"}
      textAlign="center"
      bg={
        "linear-gradient(to bottom, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0))"
      }
    >
      <VStack h={"100%"} spacing={6}>
        <Image src={LockOpend} width={"8rem"} />

        <Heading size="xl">Your Premium Access is Now Active! </Heading>

        <Text fontSize="lg" maxW="600px">
          Experience unlimited learning with our premium resources.{" "}
        </Text>
        <Spacer display={{ base: "inherit", md: "none" }} />

        <Button
          w={{ base: "full", md: "min-content" }}
          mt={"1rem"}
          variant="secondary"
          size="lg"
          onClick={() => navigate("/dashboard/learn", { replace: true })}
        >
          Start Learning
        </Button>
      </VStack>
    </Box>
  );
};

export default PaymentSuccess;
